export var INITIAL_SEARCH_PAGE_DATA = {
    productsData: undefined,
    loading: true,
    isError: false,
    error: undefined,
    dataUpdatedAt: undefined,
    rscPageLoadKey: ""
};
